import { z } from "zod";
import { zId, zInstanteUtc } from "./dominio.js";
/**
 * Marcar — o eixo independente do acerto que tem alvo próprio (RN-07).
 *
 * Fica num arquivo próprio porque não é parte do motor de sessão: um item
 * marcado continua marcado fora de qualquer sessão, e a lista de marcados é
 * navegável por si (RN-07). Misturá-lo com `estudo.ts` sugeriria que só existe
 * durante a execução. O outro eixo, "não entendi", tem tabela e rotas próprias
 * em `caderno.ts`, porque a dúvida se resolve virando nota.
 */
export const zItemAlvo = z.object({ id: zId });
export const zMarcacaoAlterada = z.object({ itemId: zId, marcado: z.boolean() });
/**
 * Uma linha da lista de marcados (RN-07).
 *
 * Carrega o **caminho** da categoria, e não só o id, porque é o caminho que dá a
 * matéria sem uma segunda consulta — é assim que `materia.ts` opera em todo o
 * resto, e é o que permite a lista agrupar por matéria (RN-38).
 *
 * O `enunciado` vem inteiro; quem trunca é a tela. Truncar aqui decidiria pela
 * interface quantos caracteres cabem, que é coisa de largura e não de contrato.
 */
export const zItemMarcado = z.object({
    itemId: zId,
    enunciado: z.string(),
    categoria: z.array(z.string()),
    /** Item arquivado continua marcado: a marca é do usuário, e some sem aviso seria pior. */
    arquivado: z.boolean(),
    marcadoEm: zInstanteUtc,
});
export const zListaDeMarcados = z.object({ marcados: z.array(zItemMarcado) });
//# sourceMappingURL=estudo-eixos.js.map